import { ValidAccountRoute } from '@ferreri/minato-auth-react';
import { Loading } from '@ferreri/prever-component-lib';
import { PageLayout } from '@ferreri/prever-component-lib/nextjs';

import { Faq } from '../modules/faq/Faq';

export default function ChatPage() {
  return (
    <ValidAccountRoute loadingComponent={<Loading />}>
      <PageLayout>
        <Faq />
      </PageLayout>
    </ValidAccountRoute>
  );
}
